import type { OnboardingOnboardingAnswers } from '@customerio/hydra-ui-api';
import { goalGerund } from './answer-recap';
import { getFirstAssetNoun, getStartingPointVariant } from './steps';

export const WORKSPACE_SETUP_LABEL = 'Setting up your workspace…';
const GENERIC_GOAL_LINE = 'Optimizing for your outcomes…';

export function agentHandoffLabels(answers: OnboardingOnboardingAnswers | undefined): string[] {
  const gerund = goalGerund(answers?.goal);
  const goalLine = gerund == null ? GENERIC_GOAL_LINE : `Optimizing for ${gerund}…`;
  const asset = getFirstAssetNoun(getStartingPointVariant(answers?.starting_point));

  return [WORKSPACE_SETUP_LABEL, goalLine, `Preparing your first ${asset}…`];
}
